module.exports = __webpack_public_path__ + "static/media/taffiethule03.31459cee.jpg";